import React from 'react';
import { ButtonLink } from '../../../components';
import { t } from '../../../i18n';
import classNames from 'classnames';
import './style.scss';

const BecomeTrainerAd = ({ isDesktopOrientation }) => {
  return (
    <div className={classNames('become-trainer-ad', `become-trainer-ad_${isDesktopOrientation ? 'big' : 'small'}`)}>
      <p className="become-trainer-ad__short-slogan">{t('LOGIN_SHORT_SLOGAN')}</p>
      <p className="become-trainer-ad__long-slogan">{t('LOGIN_LONG_SLOGAN')}</p>
      <ButtonLink
        type="green"
        href={t('TRAINER_MESSAGES')[0].link}
        text={t('GET_STARTED_TODAY_LABEL').toUpperCase()}
        className="become-trainer-ad__view-trainer-info-button"
      />
    </div>
  );
};

export default BecomeTrainerAd;
